import type { EntityType } from '../types/entity-types.ts';

/**
 * Configuration for AI writing features across different entity types.
 * This allows enabling/disabling AI improve-writing functionality
 * per entity type without code changes.
 */
export const AI_WRITING_ENABLED_ENTITIES: Record<EntityType, boolean> = {
    note: true,
    task: false,
    comment: false,
};

/**
 * Check if AI writing is enabled for a specific entity type
 */
export function isAIWritingEnabledForEntity(entityType: EntityType | undefined): boolean {
    if (!entityType) {
        return false;
    }
    return AI_WRITING_ENABLED_ENTITIES[entityType];
}
